import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=2d60d7da&scoped=true"
import script from "./workDetail.vue?vue&type=script&lang=js"
export * from "./workDetail.vue?vue&type=script&lang=js"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=2d60d7da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60d7da",
  null
  
)

export default component.exports